import { Injectable, signal } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  // Signals to track loading state and progress percentage
  loading = signal(false);
  progress = signal(0);

  // Track the number of ongoing requests
  private totalRequests = 0;

  // Show the loader when a new request starts
  show() {
    this.totalRequests++;
    this.loading.set(true);
    this.updateProgress();
  }

  // Hide the loader when all requests are completed
  hide() {
    this.totalRequests--;
    if (this.totalRequests <= 0) {
      setTimeout(() => {
        this.loading.set(false); // Hide loader after all requests finish
      }, 500); // Optional delay to smoothen transition
    }
  }

  // Update the progress based on the number of ongoing requests
  private updateProgress() {
    const progressInterval = setInterval(() => {
      // Update progress based on ongoing requests
      const progress = Math.min(100, (this.totalRequests > 0) ? (100 / this.totalRequests) : 100);
      this.progress.set(progress);

      // Once no requests are left, stop the progress update
      if (this.totalRequests <= 0) {
        clearInterval(progressInterval);
      }
    }, 100); // Update every 100ms
  }
}
